var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-aside',{attrs:{"width":"250px"}},[_c('el-menu',{staticClass:"el-menu-vertical-demo",attrs:{"default-active":_vm.activeRouter,"router":"","background-color":"#161823","unique-opened":true,"text-color":"#A7A8AC","active-text-color":"#FFF"}},_vm._l((_vm.menuList),function(item,i){return _c('siderbar-item',{key:i,attrs:{"item":item}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }